import style from "./style.module.scss";

export default function Card({
  children,
  variant = "primary",
}: {
  children?: React.ReactNode;
  variant?: "primary" | "secondary" | "tertiary" | "none";
}): JSX.Element {
  return (
    <div className={`${style.card} ${style["card--" + variant]}`}>
      {children}
    </div>
  );
}
